import useOnScreen from "../../components/UseOnScreen/UseOnScreen";
import TypingEffect from "../../components/Animation/TypingEffect";
import "../Services/TherapeuticSuport.css";

const TherapeuticSuport = () => {
  const [aboutRef,
    isVisible] = useOnScreen({threshold: 0.5, once: true});
  const therapeuticText = "Tanto para crianças quanto para adultos o acompnhante terapêutico pode ser um importante suporte emocional e social.";

  return (
    <div id="therapeutic-suport" className="" ref={aboutRef}>
      <div className="therapeutic-container">
        <div className="therapeutic-text">
          <h1>Acompanhamento <br></br>Terapêutico</h1>
          <span>
            É  um dispositivo clínico que se desenrola fora dos limites tradicionais do consultório, inserindo-se no espaço cotidiano do sujeito. O acompanhante terapêutico não é um guia nem um cuidador no sentido comum, mas alguém que ocupa um lugar estratégico, funcionando como um ponto de apoio para que o sujeito possa lidar com seus impasses e construir alternativas que façam sentido dentro de sua estrutura. O AT pode ser sugerido em casos de:
            <br></br>
            <br></br>
            <strong>
              Dificuldades em sair de casa: seja por ansiedade, medo, desmotivação ou adaptação;<br></br>
              Desafios em situações sociais: lidar com interações que geram desconforto ou isolamento;<br></br>
              Transições importantes na vida: mudanças familiares, escolares ou profissionais;<br></br>
              Processos de reabilitação: após crises emocionais ou quadros de saúde mental intensos e crônicos;<br></br>
              Momentos de vulnerabilidade psíquica: quando há sensação de estagnação, desamparo ou dificuldade em se organizar.
            </strong>
          </span>
        </div>
        <div className="therapeutic-second-text">
            {isVisible ? (
                <>
                    <TypingEffect
                        text={therapeuticText}
                        speed={70}    
                        className="therapeutic-phrase"
                    />
                </>
            ) : (
                <div className="placeholder-text">
                    <span className="therapeutic-phrase">{therapeuticText}</span>
                </div>
            )}
        </div>
      </div>
    </div>
  );
}

export default TherapeuticSuport;
